import { AbstractReelsProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractReelsProperties";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { deepEquals } from "../../../utils/deepEquals";
/**
 * Game-specific properties for the reels.
 */
export class GameReelsProperties extends AbstractReelsProperties {
    constructor() {
        super();
        this.panelProperties = new PanelProperties();
        this.panelProperties.layout = new HorizontalLayout(5);
        this.backgroundProperties = undefined;
        this.backgroundPurchaseProperties = undefined;
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameReelsProperties.js.map